import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './assets/locales/en/translation.json';

const resources = {
    en: {
        translation: en,
    },
};

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    .init({
        lng: 'en',
        debug: true,

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },

        resources,

        // if you don't want to use Suspense
        react: {
            wait: true,
            useSuspense: false,
        },
    });

export default i18n;
